import Vue from 'vue';
import VuePapaParse from 'vue-papa-parse'
import Search from './components/Search';
import BusSchedule from "./components/BusSchedule";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faCalendarCheck } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheckCircle, faCalendarCheck);

// Plugins
Vue.use(VuePapaParse); // Read CSV files
Vue.component('icon', FontAwesomeIcon);

// Components (components with Inline templates)
require('./components/singleCompany');
require('./components/ihkHeader');

// Single File components
Vue.component('ihk-search', Search);
Vue.component('ihk-bus-schedule', BusSchedule);


const app = new Vue({
  el: '#vue-app',
  delimiters: ['${', '}'],
});
